// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` /*Headers*/
#github{
	padding-right: 1em;
}

 h1,h2,h3{				
	color: black;
	font-family: Asap, sans-serif;
}

.link-1:hover{ 
	color: #172d44;
}

a{
	color:black !important;
	text-decoration:none !important;
}
			
#introduction{
	position:relative;
	background-color:#2f72b6;
	width:100%;
	height:90%;
}

/*LANDING PAGE NAVIAGTION*/
#main-wrapper{
	position: absolute;
    display: flex;
    height: 100%;
    width: 100%;
}

#top{
	position:relative;
	background-color:#2f72b6;
	width:100%;
	height:90%;
	border-bottom:4px solid white;
}

#topdesign{
	position:relative;
	text-align: center;
	overflow:hidden;
	background-color:#a2bad1d8;
	height:10%;
}
#intro_text_space1,#intro_text_space2,#intro_text_space3{
	position: relative;	
}
#intro_text_space1{background-color:#6d9dc9d3;  height:33.3%;}
#intro_text_space2{background-color:#42709b;	height:33.3%;}
#intro_text_space3{background-color:#295580;	height:33.3%;}


/*FOOTER.*/
footer{
	position: absolute;
	bottom:0;
	width:100%;
	height: 10%;
	background-color:#172d44;
	/*#204161;*/
	/*#b20000*/
}

#contact{
	position: relative;
	top:10%;
	font: 20px;
	color: white;
}



/*Responsive View*/
@media only screen and (max-width:1920px){

		#canvasPos{
			border:1px solid black;
			position: relative;
			margin-left: 20%;
			margin-right: 20%;

		}
      }
      
      
/*Tablet /Phone Landscape/ Desktop screen*/

@media only screen and (max-width:1080px){


		#canvasPos{
			border:1px solid black;
			position: relative;
			margin-left: 20%;
			margin-right: 20%;
        }
    }

    
@media only screen and (max-width:720px){

		#canvasPos{
			border:1px solid black;
			position: relative;
			left: 10%;
			margin-right: 20%;

        }
    }
    
	/*GENERAL MOBILE PHONES PORTRAIT*/
@media only screen and (max-width:480px){

		#canvasPos{
			border:1px solid black;
			position: relative;
			margin-left: 20%;
			margin-right: 20%;

        }
        
    }

    
/* SMALL MOBILE PHONES*/

@media only screen and (max-width:320px){

	#canvasPos{
		border:1px solid black;
		position: relative;
		margin-left: 20%;
		margin-right: 20%;

    }
    
};
	`, "",{"version":3,"sources":["webpack://./src/Main.css"],"names":[],"mappings":"CAAC,UAAU;AACX;CACC,kBAAkB;AACnB;;CAEC;CACA,YAAY;CACZ,6BAA6B;AAC9B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,sBAAsB;CACtB,+BAA+B;AAChC;;AAEA;CACC,iBAAiB;CACjB,wBAAwB;CACxB,UAAU;CACV,UAAU;AACX;;AAEA,0BAA0B;AAC1B;CACC,kBAAkB;IACf,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;CACC,iBAAiB;CACjB,wBAAwB;CACxB,UAAU;CACV,UAAU;CACV,6BAA6B;AAC9B;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,0BAA0B;CAC1B,UAAU;AACX;AACA;CACC,kBAAkB;AACnB;AACA,mBAAmB,0BAA0B,GAAG,YAAY,CAAC;AAC7D,mBAAmB,wBAAwB,EAAE,YAAY,CAAC;AAC1D,mBAAmB,wBAAwB,EAAE,YAAY,CAAC;;;AAG1D,UAAU;AACV;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,WAAW;CACX,wBAAwB;CACxB,WAAW;CACX,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,UAAU;CACV,YAAY;AACb;;;;AAIA,kBAAkB;AAClB;;EAEE;GACC,sBAAsB;GACtB,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;;EAElB;MACI;;;AAGN,0CAA0C;;AAE1C;;;EAGE;GACC,sBAAsB;GACtB,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;QACZ;IACJ;;;AAGJ;;EAEE;GACC,sBAAsB;GACtB,kBAAkB;GAClB,SAAS;GACT,iBAAiB;;QAEZ;IACJ;;CAEH,iCAAiC;AAClC;;EAEE;GACC,sBAAsB;GACtB,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;;QAEZ;;IAEJ;;;AAGJ,uBAAuB;;AAEvB;;CAEC;EACC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;IAEf;;AAEJ","sourcesContent":[" /*Headers*/\n#github{\n\tpadding-right: 1em;\n}\n\n h1,h2,h3{\t\t\t\t\n\tcolor: black;\n\tfont-family: Asap, sans-serif;\n}\n\n.link-1:hover{ \n\tcolor: #172d44;\n}\n\na{\n\tcolor:black !important;\n\ttext-decoration:none !important;\n}\n\t\t\t\n#introduction{\n\tposition:relative;\n\tbackground-color:#2f72b6;\n\twidth:100%;\n\theight:90%;\n}\n\n/*LANDING PAGE NAVIAGTION*/\n#main-wrapper{\n\tposition: absolute;\n    display: flex;\n    height: 100%;\n    width: 100%;\n}\n\n#top{\n\tposition:relative;\n\tbackground-color:#2f72b6;\n\twidth:100%;\n\theight:90%;\n\tborder-bottom:4px solid white;\n}\n\n#topdesign{\n\tposition:relative;\n\ttext-align: center;\n\toverflow:hidden;\n\tbackground-color:#a2bad1d8;\n\theight:10%;\n}\n#intro_text_space1,#intro_text_space2,#intro_text_space3{\n\tposition: relative;\t\n}\n#intro_text_space1{background-color:#6d9dc9d3;  height:33.3%;}\n#intro_text_space2{background-color:#42709b;\theight:33.3%;}\n#intro_text_space3{background-color:#295580;\theight:33.3%;}\n\n\n/*FOOTER.*/\nfooter{\n\tposition: absolute;\n\tbottom:0;\n\twidth:100%;\n\theight: 10%;\n\tbackground-color:#172d44;\n\t/*#204161;*/\n\t/*#b20000*/\n}\n\n#contact{\n\tposition: relative;\n\ttop:10%;\n\tfont: 20px;\n\tcolor: white;\n}\n\n\n\n/*Responsive View*/\n@media only screen and (max-width:1920px){\n\n\t\t#canvasPos{\n\t\t\tborder:1px solid black;\n\t\t\tposition: relative;\n\t\t\tmargin-left: 20%;\n\t\t\tmargin-right: 20%;\n\n\t\t}\n      }\n      \n      \n/*Tablet /Phone Landscape/ Desktop screen*/\n\n@media only screen and (max-width:1080px){\n\n\n\t\t#canvasPos{\n\t\t\tborder:1px solid black;\n\t\t\tposition: relative;\n\t\t\tmargin-left: 20%;\n\t\t\tmargin-right: 20%;\n        }\n    }\n\n    \n@media only screen and (max-width:720px){\n\n\t\t#canvasPos{\n\t\t\tborder:1px solid black;\n\t\t\tposition: relative;\n\t\t\tleft: 10%;\n\t\t\tmargin-right: 20%;\n\n        }\n    }\n    \n\t/*GENERAL MOBILE PHONES PORTRAIT*/\n@media only screen and (max-width:480px){\n\n\t\t#canvasPos{\n\t\t\tborder:1px solid black;\n\t\t\tposition: relative;\n\t\t\tmargin-left: 20%;\n\t\t\tmargin-right: 20%;\n\n        }\n        \n    }\n\n    \n/* SMALL MOBILE PHONES*/\n\n@media only screen and (max-width:320px){\n\n\t#canvasPos{\n\t\tborder:1px solid black;\n\t\tposition: relative;\n\t\tmargin-left: 20%;\n\t\tmargin-right: 20%;\n\n    }\n    \n};\n\t"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
